import React, {Component} from 'react';
import _ from "lodash";
import {Button, Modal,Row, Col, FormControl } from 'react-bootstrap';

export default class ConfirmModalDialog extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            inputText: '',
            confirmationDone: false,
        };
        this.confirmAction = _.throttle(this.confirmAction, 2000, {
            'leading': true,
            'trailing': false
        });
    }
    confirmAction(data){
        this.props.confirmActionHandler(data)
    }
    cancel(){
        this.setState({inputText: false, confirmationDone: false})
        this.props.closeModal()
        if (this.props.cancelActionHandler) {
            this.props.cancelActionHandler()
        }
    }
    closeModal() {
        this.setState({inputText: false, confirmationDone: false})
        this.props.closeModal()
    }
    onInputTextChange(e) {
        var updatedState = {inputText: e.target.value}
        if (e.target.value.toLowerCase() == 'yes') {
            updatedState.confirmationDone = true;
        } else {
            updatedState.confirmationDone = false;
        }
        this.setState(updatedState)
    }

    render() {
         if (!this.props.show) {
            return null;
        }
        return (
        <Modal  show={this.props.show}
                onExited={(e) => this.cancel()}
                  onHide={() => {
                      this.closeModal()
                  }}
                 >
            <Modal.Header closeButton>
                {this.props.type == 'confirmationWithText' ?
                    <Modal.Title>
                        <div>
                            <div>{ this.props.title}</div>
                            <div>(type to confirm)</div>
                        </div>
                    </Modal.Title> :
                    <Modal.Title>{ this.props.title}</Modal.Title>
                }
            </Modal.Header>
            {this.props.type == 'confirmationWithText' &&
            <Modal.Body >
                 <Row>
                    <Col lg={54} md={5} sm={8} xs={12}>
                        <FormControl type="text"
                                     onChange={this.onInputTextChange.bind(this)}
                        />
                    </Col>
                 </Row>
            </Modal.Body>
            }
            {!_.isUndefined(this.props.dialogContent)  &&
            <Modal.Body >
                {this.props.dialogContent()}
            </Modal.Body>
            }
            <Modal.Footer>
                 <Button
                    onClick={(e) => this.cancel()}>{this.props.cancelButtonTitle ? this.props.cancelButtonTitle : 'Cancel'}</Button>
                {_.get(this.props,'buttonTitle','') !== 'doNotDisplay' &&
                <Button
                    disabled={this.props.type == 'confirmationWithText' ? !this.state.confirmationDone : false}
                    onClick={(e) => this.confirmAction({buttonNumber: 1}) } className="left20"
                    bsStyle="primary">{this.props.buttonTitle ? this.props.buttonTitle : 'Confirm'}</Button>
                }
                {!_.isUndefined(this.props.secondButtonTitle)  &&
                <Button
                    onClick={(e)=>  this.confirmAction({buttonNumber:2}) } className="left20" bsStyle="primary">{ this.props.secondButtonTitle  }</Button>
                }

            </Modal.Footer>
        </Modal>


        );
    }
}

